var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('focus-trap', {
    attrs: {
      "active": _vm.isVisible,
      "initial-focus": function initialFocus() {
        return _vm.$refs.closeBtn;
      },
      "escape-deactivates": true,
      "return-focus-on-deactivate": true
    }
  }, [_c('div', {
    staticClass: "buy-panel"
  }, [_vm.buyPanelConfiguration.wishlist_notification ? _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [_c('tmall-wishlist-notification', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.showTmallWishlistNotification,
      expression: "showTmallWishlistNotification"
    }],
    attrs: {
      "favoriteSaved": _vm.tmallWishlistSaved
    }
  })], 1) : _vm._e(), _c('section', [_c('div', {
    staticClass: "buy-panel-backdrop",
    on: {
      "click": _vm.hideBuyPanel
    }
  }), _c('div', {
    class: ['buy-panel-wrapper', {
      'is-tmall': _vm.$store.getters['utils/tmallEnabled']
    }]
  }, [_c('button', {
    ref: "closeBtn",
    class: _vm.isCloseButtonAsText ? 'buy-panel-wrapper-close-text' : 'buy-panel-wrapper-close',
    attrs: {
      "aria-label": _vm.translations.groupShareClose
    },
    on: {
      "click": _vm.hideBuyPanel
    }
  }, [_vm.isCloseButtonAsText ? _c('span', [_vm._v(_vm._s(_vm.translations.buyPanelTmallBack))]) : _c('span', {
    staticClass: "buy-panel-wrapper-close-icon icon-close"
  })]), _c('div', {
    class: "buy-panel-wrapper-buymenu ".concat(_vm.zoomLevelHigh ? 'zoom-level-high' : '')
  }, [_c('div', {
    staticClass: "buy-panel-wrapper-buymenu-overlay"
  }, [!_vm.configuration.enableSnapshotService ? _c('product-image', {
    attrs: {
      "isSpinnerPositionHigher": _vm.buyPanelConfiguration.spinner_position_higher,
      "recipeId": _vm.recipeId
    }
  }) : _c('div', {
    class: "buy-panel-product-image ".concat(_vm.zoomLevelHigh ? 'zoom-level-high' : '')
  }, [_vm.isVisible ? _c('snapshot-image', {
    attrs: {
      "isSpinnerPositionHigher": _vm.buyPanelConfiguration.spinner_position_higher
    }
  }) : _vm._e()], 1), _c('product-info', {
    attrs: {
      "isModelPriceLabelPositionCentered": _vm.buyPanelConfiguration.model_price_label_position_centered,
      "isFavoritesOnly": _vm.isFavoritesOnly,
      "checkUGC": _vm.checkUGC,
      "tmallIsUGCMS": _vm.tmallIsUGCMS
    }
  }), _c('div', {
    class: ['tile-selectors__options', {
      'reverse': _vm.configuration.size_selector_tiles.buyPanel && !_vm.disableQuantity
    }]
  }, [!_vm.configuration.size_selector_tiles.buyPanel || !_vm.configuration.quantity_selector_tiles.buyPanel ? _c('size-selection', {
    ref: "buyPanelFormContainer",
    attrs: {
      "isQuantityLabelHide": _vm.buyPanelConfiguration.quantity_label_hide,
      "isQuantitySelectHide": _vm.buyPanelConfiguration.quantity_select_hide,
      "isFavoritesOnly": _vm.isFavoritesOnly,
      "showSizeGuide": _vm.showSizeGuide,
      "buyPanelIsLoading": _vm.isLoading,
      "disableQuantity": _vm.disableQuantity
    }
  }) : _vm._e(), _vm.configuration.size_selector_tiles.buyPanel || _vm.configuration.quantity_selector_tiles.buyPanel ? _c('tiles-selection', {
    ref: "buyPanelFormContainer",
    attrs: {
      "showSizeTiles": _vm.configuration.size_selector_tiles.buyPanel,
      "showQuantityTiles": _vm.configuration.quantity_selector_tiles.buyPanel && !_vm.buyPanelConfiguration.quantity_select_hide,
      "buyPanelIsLoading": _vm.isLoading,
      "customClass": "tile-selectors buy-panel-size-selection"
    }
  }) : _vm._e()], 1)], 1), _vm.isMyAddToCart && !_vm.disableShare ? _c('save-design', {
    attrs: {
      "isUGCApplied": _vm.checkUGC,
      "tmallIsUGCMS": _vm.tmallIsUGCMS,
      "onlyFavorites": _vm.isFavoritesOnly,
      "isWishlistButtonEnabled": _vm.buyPanelConfiguration.wishlist_button_enabled
    }
  }) : _vm._e(), _vm.showBuyPanelExclusionMessage ? _c('p', {
    staticClass: "buy-panel-exclusion-message"
  }, [_c('svg', {
    staticClass: "buy-panel-exclusion-message-icon",
    attrs: {
      "viewBox": "0 0 32 32",
      "id": "info",
      "aria-hidden": "true",
      "focusable": "false"
    }
  }, [_c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M16 25a9 9 0 1 0 0-18 9 9 0 0 0 0 18Zm0 2a11 11 0 1 0 0-22 11 11 0 0 0 0 22Z",
      "clip-rule": "evenodd"
    }
  }), _c('path', {
    attrs: {
      "fill-rule": "evenodd",
      "d": "M16 22a1 1 0 0 1-1-1v-7a1 1 0 1 1 2 0v7a1 1 0 0 1-1 1Z",
      "clip-rule": "evenodd"
    }
  }), _c('path', {
    attrs: {
      "d": "M17 11a1 1 0 1 1-2 0 1 1 0 0 1 2 0Z"
    }
  })]), _c('span', [_vm._v(_vm._s(_vm.translations.buyPanelExclusionMessage))])]) : _vm._e(), _vm.isMyAddToCart && !_vm.isFavoritesOnly && (!_vm.checkUGC || _vm.tmallIsUGCMS) || !_vm.isMyAddToCart ? _c('add-to-cart', {
    attrs: {
      "isMyAddToCart": _vm.isMyAddToCart,
      "disableShare": _vm.disableShare,
      "isAddToCartWideCta": _vm.buyPanelConfiguration.add_to_cart_wide_cta
    }
  }) : _vm._e()], 1)])]), _vm.showSizeGuide ? _c('size-guide-modal') : _vm._e()], 1)]);
}
var staticRenderFns = []

export { render, staticRenderFns }